<script>
  import {reset_url} from "./Utils/RouterUtils.svelte";
  import {normalized_video_store} from "./Utils/stores";
  import {authStore} from "./stores/authStore";
  import {active_video_store} from "./Utils/stores";
  import {playlistProgressStore} from "./stores/authStore";
  import Debug from "./Utils/Debug.svelte";
  import SingleVideoTile from "./SingleVideoTile.svelte";
  import ProgressIndicator from "./ProgressIndicator.svelte";
  import CategoryContainer from "./CategoryContainer.svelte";
  import CategoryContainerHeader from "./CategoryContainerHeader.svelte";
  import CategoryContainerBody from "./CategoryContainerBody.svelte";
  import CategorySidebar from "./CategorySidebar.svelte";
  import CategorySidebarTitle from "./CategorySidebarTitle.svelte";
  import CategorySidebarDescription from "./CategorySidebarDescription.svelte";
  import CategoryMainPanel from "./CategoryMainPanel.svelte";
  import CategoryGrid from "./CategoryGrid.svelte";
  import LoginButton from "./LoginButton.svelte";

  $: activePlaylist = $active_video_store.active_playlist;
</script>

<CategoryContainer>
  <CategoryContainerHeader>
    <div class="vec-hidden md:vec-flex vec-text-sm vec-items-center vec-w-full vec-stretch">
      <a on:click={reset_url} class="vec-cursor-pointer vec-text-darkGrey hover:vec-text-black hover:vec-underline">Tutorials</a> 
      <svg xmlns="http://www.w3.org/2000/svg" width="5.207" height="9.414" viewBox="0 0 5.207 9.414" class="vec-mx-3">
          <path id="BC_Divider" data-name="BC Divider" d="M1,1,5,5,9,1" transform="translate(-0.293 9.707) rotate(-90)" fill="none" stroke="#666" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      </svg> {$active_video_store.active_playlist.title}
    </div>
    <div class="vec-flex vec-w-full md:vec-max-w-[33%] vec-justify-self-end vec-items-center md:vec-text-right">
        <LoginButton/>
        {#if $authStore.loggedIn}
        <ProgressIndicator progress={$playlistProgressStore.playlistProgress[activePlaylist.slug.current]} />      
        {/if}
    </div>
  </CategoryContainerHeader>
  <CategoryContainerBody>
    <CategorySidebar>
      <CategorySidebarTitle>{activePlaylist.title}</CategorySidebarTitle>
      <CategorySidebarDescription>{$active_video_store.active_playlist.description}</CategorySidebarDescription>
    </CategorySidebar>
    <CategoryMainPanel>
      <CategoryGrid>
        {#each $active_video_store.filtered_videos as video (video._id)}
          <SingleVideoTile video={$normalized_video_store.videos[video.slug.current]}/>
        {/each}
      </CategoryGrid>
    </CategoryMainPanel>
  </CategoryContainerBody>
</CategoryContainer>
